import E3StaticData from "@/pages/e3/E3StaticData/main";
import E3TimeSeries from "@/pages/e3/E3TimeSeries/main";
import E3Transactions from "@/pages/e3/E3Transactions/main";
import { Route, Routes } from "react-router-dom";
import E3DownloadCenter from "./E3DownloadCenter/main";
import E3Issuers from "./E3Issuers/main";
import E3PdfPageSelection from "./E3PdfPageSelection/main";
import E3Portfolios from "./E3Portfolios/main";
import E3DataUpload from "./E3DataUpload/main";

export default function E3Routes() {
  return (
    <Routes>
      <Route path="e3_static_data/*" element={<E3StaticData />} />
      <Route path="e3_time_series/*" element={<E3TimeSeries />} />
      <Route path="e3_transactions/*" element={<E3Transactions />} />
      <Route path="e3_portfolios/*" element={<E3Portfolios />} />
      <Route path="e3_issuers/*" element={<E3Issuers />} />
      <Route path="e3_pdf_page_selection/*" element={<E3PdfPageSelection />} />
      <Route path="e3_download_center/*" element={<E3DownloadCenter />} />
      <Route path="e3_data_upload/*" element={<E3DataUpload />} />
    </Routes>
  );
}
